import { Component, Vue, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { documentCard } from '@/shared/model/document-card.model';
import { checkIfIsBase64Image, getHostName, getSavedUserKey, onlyInLeft, timeDifference } from '@/util/ds-util';
import RefCardItem from '@/shared/cards/briefing/ref-card-item/ref-card-item.vue';
import { namespace } from 'vuex-class';
import { removeUnUsedSpace } from '@/util/string.util';
import vueCustomScrollbar from 'vue-custom-scrollbar';

const briefingStore = namespace('briefingStore');

@Component({
  components: {
    'ref-item': RefCardItem,
    vueCustomScrollbar: vueCustomScrollbar,
  },
})
export default class RefSearchComponent extends Vue {
  @briefingStore.Getter
  getAddingReferenceDocuments!: Array<any>;

  @briefingStore.Mutation
  public setAddingReferenceDocuments!: (payload: any) => void;

  public get userIdentity(): any {
    return this.$store.getters?.account
      ? this.$store.getters?.account
      : this.$store.getters?.userIdentity
      ? this.$store.getters?.userIdentity
      : JSON.parse(localStorage.getItem('localStorageUser'))
      ? JSON.parse(localStorage.getItem('localStorageUser'))
      : null;
  }

  scrollSettings = {
    wheelPropagation: false,
  };
  queries = '';
  isShowSpinner = false;
  dataSearch = [];
  allData = [];
  tabTypeActive = 'ALL';
  loaderDisable = true;
  internalSearch = [];
  metaSearch = [];
  externalSearch = [];
  isShowMore = false;
  isMoreResults = false;
  noMoreResult = false;
  tabActive = 1;
  selectedItems = [];
  language: any = this.$store.getters.currentLanguage;
  languages: any = this.$store.getters.languages;
  oldLanguage: any = this.$store.getters.currentLanguage;
  totalSelected = 0;
  checked = false;
  gooverData = [];
  webData = [];
  newsData = [];
  videoData = [];
  documentData = [];
  tempTabTypeActive = 'ALL';
  tempKeyword = '';
  acceptOverCall = false;
  isSearchAll = false;
  isSearchGoover = false;
  isSearchWebsite = false;
  isSearchNews = false;
  isSearchVideo = false;
  isSearchDocument = false;
  isLoading = false;
  isLoadMoreGoover = true;
  isLoadMoreWebsite = true;
  isLoadMoreNews = true;
  isLoadMoreVideo = true;
  isLoadMoreDocument = true;
  pageNumberGoover = 1;
  pageNumberWebsite = 1;
  pageNumberNews = 1;
  pageNumberVideo = 1;
  pageNumberDocument = 1;
  isFirstTimesSearch = true;
  isShowNoResultAll = false;

  @Watch('language')
  languageChage() {
    this.allData = [];
    // this.page = 0;
    this.$emit('setLanguage', this.language);
  }

  @Watch('getAddingReferenceDocuments')
  onGetAddingReferenceDocumentsChange() {
    if (this.getAddingReferenceDocuments === null || this.getAddingReferenceDocuments.length === 0) {
      this.selectedItems = [];
    }
  }

  @Watch('isLoading')
  onIsLoadingChange() {
    this.isShowNoResultAll =
      (this.gooverData === null || this.gooverData?.length === 0) &&
      (this.webData === null || this.webData?.length === 0) &&
      (this.newsData === null || this.newsData?.length === 0) &&
      (this.videoData === null || this.videoData?.length === 0) &&
      (this.documentData === null || this.documentData?.length === 0) &&
      !this.isFirstTimesSearch &&
      !this.isLoading;
  }

  @Watch('isLoading')
  onIsLoadingChangeForLoading() {
    if (!this.isLoading) {
      this.isLoading = false;
    } else {
      this.startLoadingTimeout();
    }
  }

  startLoadingTimeout() {
    const timerLoadingPage = setTimeout(() => {
      if (this.isLoading) {
        this.isLoading = false;
        // this.showResponseMessage(`${this.$t('toast.connection.timeout')}`, `${this.$t('toast.title.warn')}`, 'warning', 5000);
      }
    }, 25000);

    return () => clearTimeout(timerLoadingPage);
  }

  loadMoreSearchResultByNextPage(tabLoadMore: string) {
    this.isLoading = true;

    switch (tabLoadMore) {
      case 'goover':
        this.pageNumberGoover += 1;
        this.searching('GOOVER', false, this.pageNumberGoover, 'GOOVER').then(() => {
          this.isLoading = false;
        });
        break;
      case 'web':
        this.pageNumberWebsite += 1;
        this.searching('WEB', false, this.pageNumberWebsite, 'WEB').then(() => {
          this.isLoading = false;
        });
        break;
      case 'news':
        this.pageNumberNews += 1;
        this.searching('NEWS', false, this.pageNumberNews, 'NEWS').then(() => {
          this.isLoading = false;
        });
        break;
      case 'video':
        this.pageNumberVideo += 1;
        this.searching('VIDEO', false, this.pageNumberVideo, 'VIDEO').then(() => {
          this.isLoading = false;
        });
        break;
      case 'document':
        this.pageNumberDocument += 1;
        this.searching('searchFileType', false, this.pageNumberDocument, 'searchFileType').then(() => {
          this.isLoading = false;
        });
        break;
      default:
        break;
    }
  }

  searchData(isSearch?: boolean) {
    this.queries = removeUnUsedSpace(this.queries ? this.queries : '');
    const tempCheckedKeyword = removeUnUsedSpace(this.queries ? this.queries : '');
    if (!this.queries || !tempCheckedKeyword || (this.tempKeyword === tempCheckedKeyword && !isSearch)) {
      return;
    } else {
      if (this.tabActive === 1 && !isSearch) {
        this.cleanDataList();
        this.isSearchAll = false;
        this.isSearchGoover = false;
        this.isSearchWebsite = false;
        this.isSearchNews = false;
        this.isSearchVideo = false;
        this.isSearchDocument = false;
      }
    }

    this.isLoading = true;

    switch (this.tabActive) {
      case 1:
        this.acceptOverCall = true;
        this.onTabSearch('GOOVER', 2, false, true).then(() => {
          this.onTabSearch('WEB', 3, false, true).then(() => {
            this.onTabSearch('NEWS', 4, false, true).then(() => {
              this.onTabSearch('VIDEO', 5, false, true).then(() => {
                this.onTabSearch('searchFileType', 6, false, true).then(() => {
                  this.tabActive = 1;
                  this.acceptOverCall = false;
                  this.isSearchAll = true;
                  this.isSearchGoover = true;
                  this.isSearchWebsite = true;
                  this.isSearchNews = true;
                  this.isSearchVideo = true;
                  this.isSearchDocument = true;
                  this.isLoading = false;
                });
              });
            });
          });
        });

        break;
      case 2:
        this.setAndCleanDataForGoover();
        this.onTabSearch('GOOVER', 2, false, false).then(() => {
          this.isLoading = false;
        });
        break;
      case 3:
        this.setAndCleanDataForWebsite();
        this.onTabSearch('WEB', 3, false, false).then(() => {
          this.isLoading = false;
        });
        break;
      case 4:
        this.setAndCleanDataForNews();
        this.onTabSearch('NEWS', 4, false, false).then(() => {
          this.isLoading = false;
        });
        break;
      case 5:
        this.setAndCleanDataForVideo();
        this.onTabSearch('VIDEO', 5, false, false).then(() => {
          this.isLoading = false;
        });
        break;
      case 6:
        this.setAndCleanDataForDocument();
        this.onTabSearch('searchFileType', 6, false, false).then(() => {
          this.isLoading = false;
        });
        break;
      default:
        break;
    }
  }

  setAndCleanDataForGoover() {
    this.isSearchAll = false;
    this.isSearchGoover = true;
    this.isSearchWebsite = false;
    this.isSearchNews = false;
    this.isSearchVideo = false;
    this.isSearchDocument = false;
    this.cleanDataList();
  }

  setAndCleanDataForWebsite() {
    this.isSearchAll = false;
    this.isSearchGoover = false;
    this.isSearchWebsite = true;
    this.isSearchNews = false;
    this.isSearchVideo = false;
    this.isSearchDocument = false;
    this.cleanDataList();
  }

  setAndCleanDataForNews() {
    this.isSearchAll = false;
    this.isSearchGoover = false;
    this.isSearchWebsite = false;
    this.isSearchNews = true;
    this.isSearchVideo = false;
    this.isSearchDocument = false;
    this.cleanDataList();
  }

  setAndCleanDataForVideo() {
    this.isSearchAll = false;
    this.isSearchGoover = false;
    this.isSearchWebsite = false;
    this.isSearchNews = false;
    this.isSearchVideo = true;
    this.isSearchDocument = false;
    this.cleanDataList();
  }

  setAndCleanDataForDocument() {
    this.isSearchAll = false;
    this.isSearchGoover = false;
    this.isSearchWebsite = false;
    this.isSearchNews = false;
    this.isSearchVideo = false;
    this.isSearchDocument = true;
    this.cleanDataList();
  }

  cleanDataList() {
    this.gooverData = [];
    this.webData = [];
    this.newsData = [];
    this.videoData = [];
    this.documentData = [];
    this.allData = [];
    this.isLoadMoreGoover = true;
    this.isLoadMoreWebsite = true;
    this.isLoadMoreNews = true;
    this.isLoadMoreVideo = true;
    this.isLoadMoreDocument = true;
    this.pageNumberGoover = 1;
    this.pageNumberWebsite = 1;
    this.pageNumberNews = 1;
    this.pageNumberVideo = 1;
    this.pageNumberDocument = 1;
  }

  async onClickTab(searchTypeInput: string, tabActiveInput: number, isClick: boolean, isSkipMapData?: boolean) {
    this.isLoading = true;

    await this.onTabSearch(searchTypeInput, tabActiveInput, isClick, isSkipMapData).then(() => {
      if (tabActiveInput !== 1) {
        this.isLoading = false;
      }
    });
  }

  async onTabSearch(searchTypeInput: string, tabActiveInput: number, isClick: boolean, isSkipMapData?: boolean) {
    this.queries = removeUnUsedSpace(this.queries ? this.queries : '');
    const tempCheckedKeyword = removeUnUsedSpace(this.queries ? this.queries : '');
    this.tabActive = tabActiveInput ? tabActiveInput : this.tabActive;
    this.tabTypeActive = searchTypeInput ? searchTypeInput : this.tabTypeActive;

    if (!this.queries || !tempCheckedKeyword || isClick) {
      this.queries = this.isFirstTimesSearch ? tempCheckedKeyword : this.tempKeyword;
      if (this.isSearchAll) {
        this.isLoading = false;
        return;
      }
    }

    if (!this.queries || !tempCheckedKeyword) {
      this.isLoading = false;
      return;
    }

    if (!this.acceptOverCall && this.tempKeyword === tempCheckedKeyword && this.tempTabTypeActive === this.tabTypeActive) {
      return;
    }

    if (isClick && this.isFirstTimesSearch) {
      this.isLoading = false;
      return;
    }

    if (searchTypeInput === 'ALL') {
      this.searchData(true);
      return;
    }

    if (this.acceptOverCall) {
      if (
        (this.tabActive === 2 && this.isSearchGoover) ||
        (this.tabActive === 3 && this.isSearchWebsite) ||
        (this.tabActive === 4 && this.isSearchNews) ||
        (this.tabActive === 5 && this.isSearchVideo) ||
        (this.tabActive === 6 && this.isSearchDocument)
      ) {
        return;
      }
    }

    if (
      (this.tabActive === 2 && this.isSearchGoover && isClick) ||
      (this.tabActive === 3 && this.isSearchWebsite && isClick) ||
      (this.tabActive === 4 && this.isSearchNews && isClick) ||
      (this.tabActive === 5 && this.isSearchVideo && isClick) ||
      (this.tabActive === 6 && this.isSearchDocument && isClick)
    ) {
      return;
    } else {
      if (this.tabActive === 2) {
        this.isSearchGoover = true;
      }
      if (this.tabActive === 3) {
        this.isSearchWebsite = true;
      }
      if (this.tabActive === 4) {
        this.isSearchNews = true;
      }
      if (this.tabActive === 5) {
        this.isSearchVideo = true;
      }
      if (this.tabActive === 6) {
        this.isSearchDocument = true;
      }
    }

    this.tempTabTypeActive = this.tabTypeActive;
    this.tempKeyword = tempCheckedKeyword;

    this.allData.splice(0, this.allData.length);
    this.internalSearch.splice(0, this.internalSearch.length);
    this.metaSearch.splice(0, this.metaSearch.length);

    await this.searching(searchTypeInput ? searchTypeInput : this.tabTypeActive, isSkipMapData);
  }

  async searching(searchTypeInput: string, isSkipMapData?: boolean, pageNumberInput?: number, tabSearching?: string) {
    this.metaSearch = [];

    if (tabSearching) {
      this.queries = this.tempKeyword;
    }

    if (this.dataSearch.length > 0 && this.getParam() == null) {
      this.loaderDisable = true;
    } else {
      const param = new (class {
        [x: string]: any;
      })();
      param.searchType = searchTypeInput ? searchTypeInput : this.tabTypeActive;
      param.requestId = new Date().getTime();

      await axios
        .get(
          searchTypeInput === 'GOOVER'
            ? 'api/related-content/searchInternal?keyword=' +
                this.queries +
                '&page=' +
                (pageNumberInput ? pageNumberInput : 1) +
                '&lang=' +
                this.getLanguage() +
                '&user_key=' +
                getSavedUserKey()
            : 'api/learning/search' + this.getParam() + '/' + (pageNumberInput ? pageNumberInput : 1) + '/' + this.queries,
          {
            params: searchTypeInput === 'GOOVER' ? null : param,
          }
        )
        .then(async res => {
          this.isFirstTimesSearch = false;
          if (this.tabActive !== 2 && searchTypeInput !== 'GOOVER' && tabSearching !== 'GOOVER') {
            if (res.data.internalSearch) {
              this.internalSearch = res.data.internalSearch.body;
              // @ts-ignore
              this.dataSearch = this.internalSearch.documents;
            }

            if (res.data.metaSearch) {
              if (res.data.metaSearch.body.result === 'NO_MORE_DATA' && res.data.metaSearch.body.data.length === 0) {
                switch (tabSearching) {
                  case 'GOOVER':
                    this.isLoadMoreGoover = false;
                    break;
                  case 'WEB':
                    this.isLoadMoreWebsite = false;
                    break;
                  case 'NEWS':
                    this.isLoadMoreNews = false;
                    break;
                  case 'VIDEO':
                    this.isLoadMoreVideo = false;
                    break;
                  case 'searchFileType':
                    this.isLoadMoreDocument = false;
                    break;
                  default:
                    break;
                }
                return;
              }

              if (this.tabActive === 3 || searchTypeInput === 'WEB' || tabSearching === 'WEB') {
                if (res.data.metaSearch.body.data && res.data.metaSearch.body.data.length > 0) {
                  const size = res.data.metaSearch.body.data.length;
                  const arrChannel = [
                    { key: 'google', value: 'search_result' },
                    { key: 'medium', value: 'stories' },
                    { key: 'github', value: 'repositories' },
                  ];
                  for (let i = 0; i < size; i++) {
                    const value = arrChannel.find(item => item.key == res.data.metaSearch.body.data[i].channel)?.value;
                    if (res.data.metaSearch.body.data[i][value])
                      this.metaSearch = this.metaSearch.concat(res.data.metaSearch.body.data[i][value]);
                  }
                }

                if (this.metaSearch.length <= 0) {
                  this.isLoadMoreWebsite = false;
                  return;
                }
              } else {
                this.externalSearch = res.data.metaSearch.body;
                // @ts-ignore
                this.metaSearch = this.externalSearch.data;
              }
              this.isMoreResults = true;
            }

            if (!isSkipMapData) {
              switch (tabSearching) {
                case 'GOOVER':
                  this.allData = [...this.gooverData];
                  break;
                case 'WEB':
                  this.allData = [...this.webData];
                  break;
                case 'NEWS':
                  this.allData = [...this.newsData];
                  break;
                case 'VIDEO':
                  this.allData = [...this.videoData];
                  break;
                case 'searchFileType':
                  this.allData = [...this.documentData];
                  break;
                default:
                  break;
              }

              this.allData = this.allData
                .concat(await this.badArrToGoodArr(this.dataSearch, this.tabActive === 6))
                .concat(await this.badArrToGoodArr(this.metaSearch, this.tabActive === 6));
              this.reSelectItem();
            } else {
              this.dataSearch.forEach((item, index) => {
                this.allData.push(item);
                this.metaSearch.forEach((val, ind) => {
                  if (index == ind) {
                    this.allData.push(val);
                  }
                });
              });
              if (this.dataSearch.length < this.metaSearch.length) {
                for (let i = this.dataSearch.length; i < this.metaSearch.length; i++) {
                  this.allData.push(this.metaSearch[i]);
                }
              }
              this.allData = await this.badArrToGoodArr(this.allData, this.tabActive === 6);
              this.reSelectItem();
            }

            switch (this.tabActive) {
              case 2:
                this.gooverData = [...(this.allData ? this.allData : [])];
                break;
              case 3:
                this.webData = [...(this.allData ? this.allData : [])];
                break;
              case 4:
                this.newsData = [...(this.allData ? this.allData : [])];
                break;
              case 5:
                this.videoData = [...(this.allData ? this.allData : [])];
                break;
              case 6:
                this.documentData = [...(this.allData ? this.allData : [])];
                break;
              default:
                break;
            }

            if (tabSearching) {
              switch (tabSearching) {
                case 'GOOVER':
                  this.gooverData = [...(this.allData ? this.allData : [])];
                  break;
                case 'WEB':
                  this.webData = [...(this.allData ? this.allData : [])];
                  break;
                case 'NEWS':
                  this.newsData = [...(this.allData ? this.allData : [])];
                  break;
                case 'VIDEO':
                  this.videoData = [...(this.allData ? this.allData : [])];
                  break;
                case 'searchFileType':
                  this.documentData = [...(this.allData ? this.allData : [])];
                  break;
                default:
                  break;
              }
            }

            this.isShowMore = false;
          } else {
            if (res?.data?.body?.data?.length === 0) {
              this.isLoadMoreGoover = false;
              return;
            }

            if (res.data && res.data.body && res.data.body.data[0] && res.data.body.data[0].search_result) {
              if (res.data.body.data[0].search_result.length === 0) {
                this.isLoadMoreGoover = false;
                return;
              }
              this.allData = await this.badArrToGoodArr([...res.data.body.data[0].search_result], false);

              if (this.gooverData && this.gooverData.length > 0) {
                this.gooverData = [...this.gooverData, ...this.allData];
              } else {
                this.gooverData = [...(this.allData ? this.allData : [])];
              }

              this.reSelectItem();
            }
          }
        })
        .catch(error => {
          this.isShowMore = false;
          this.noMoreResult = false;
          this.isFirstTimesSearch = false;
        });
    }
  }

  getLanguage() {
    return this.userIdentity?.langKey || JSON.parse(localStorage.getItem('localStorageUser'))?.langKey || 'en';
  }

  public getParam() {
    if (this.language != this.oldLanguage) this.language = this.oldLanguage;
    else this.oldLanguage = this.language;
    const language = this.language;

    if (!language) {
      return null;
    }
    return '/' + language;
  }

  reSelectItem() {
    try {
      if (this.getAddingReferenceDocuments !== null && this.allData !== null) {
        this.allData.forEach(item => {
          const matchingItem = this.getAddingReferenceDocuments.find(
            itemSelected =>
              (item.docId === itemSelected.docId && item.link === itemSelected.url) ||
              (item.docId === itemSelected.docId && item.url === itemSelected.url)
          );
          if (matchingItem) {
            const index = this.allData.indexOf(item);
            if (index !== -1) {
              this.allData.splice(index, 1, matchingItem);
            }
          }
        });
      }
    } catch (e) {
      // todo
    }
  }

  async badArrToGoodArr(arr, typeDownload?) {
    const results: documentCard[] = await Promise.all(
      arr
        .filter(item => item.title || item.description || [item.imgBase64 ? item.imgBase64 : item.img ? item.img : ''])
        .map(async item => {
          // console.log(item.searchType);
          const objectTmp = new documentCard();
          if (item.author) objectTmp.author = item.author;
          else objectTmp.author = getHostName(item.link);
          objectTmp.title = item.title ? item.title : '';
          objectTmp.content = item.content ? item.content : '';
          objectTmp.keyword = item.keyword ? item.keyword : '';
          objectTmp.type = typeDownload ? 'DOWNLOAD' : 'URL';
          objectTmp.searchType = item.searchType ? this.generateSearchType(item.searchType) : 'WEB';
          objectTmp.addedAt = item.org_date ? item.org_date : item.datetime ? timeDifference(new Date(), new Date(item.datetime)) : '';
          objectTmp.url = item.link ? item.link : item.url ? item.url : '';
          objectTmp.favicon = item.favicon ? (!checkIfIsBase64Image(item.favicon) ? item.favicon : '') : '';
          // objectTmp.docId = item.docId ? item.docId : '';
          objectTmp.noConvertTime = true;
          objectTmp.tags = item.tags ? item.tags : [''];
          objectTmp.typeRemove = 'search';
          // objectTmp.create_date = item.create_date ? item.create_date : item.org_date ? item.org_date : '';
          objectTmp.create_date = item.create_date ? item.create_date : '';
          // objectTmp.channel = 'Search';
          objectTmp.channel = item.link
            ? getHostName(item.link)
            : item.url
            ? getHostName(item.url)
            : item.path
            ? getHostName(item.path)
            : item.author
            ? getHostName(item.author)
            : item.channel
            ? item.channel
            : '';
          objectTmp.mediaType = item.mediaType
            ? item.mediaType
            : [item.searchType ? this.generateMediaType(item.searchType, item.docId) : 'WEB'];
          objectTmp.description = item.description ? item.description : '';
          objectTmp.image_uri = item.image_uri ? item.image_uri : [''];
          objectTmp.image_uri_thumbnail = item.img ? (!checkIfIsBase64Image(item.img) ? item.img : '') : '';
          objectTmp.path = item.path ? item.path : item.link ? item.link : item.url ? item.url : '';
          objectTmp.service_html = item.service_html ? item.service_html : '';
          objectTmp.published_at = item.published_at ? item.published_at : '';
          objectTmp.forcedClustering = false;
          objectTmp.targetBpId = '';
          objectTmp.lang = '';
          objectTmp.originDate = item.org_date ? item.org_date : '';
          objectTmp.parentDocId = item.parentDocId ? item.parentDocId : item.docId ? item.docId : '';
          objectTmp.docId = item.docId ? item.docId : item.parentDocId ? item.parentDocId : '';
          objectTmp.docType = item.docType ? item.docType : 1;
          objectTmp.isInsideGroup = false;
          objectTmp.userKey = '';
          objectTmp.writer = item.writer ? item.writer : item.author ? [item.author] : [''];

          return objectTmp;
        })
    );

    //remove duplicate
    return onlyInLeft(results, this.allData, ['docId', 'url']);
  }

  generateSearchType(searchTypeInput: string) {
    let tempSearchType = 'WEB';

    switch (searchTypeInput) {
      case 'PDF':
        tempSearchType = 'FILE';
        break;
      case 'PPT':
        tempSearchType = 'FILE';
        break;
      case 'DOC':
        tempSearchType = 'FILE';
        break;
      default:
        tempSearchType = searchTypeInput;
        break;
    }
    return tempSearchType;
  }

  generateMediaType(searchTypeInput: string, docIdInput: string) {
    let tempMediaType = 'WEB';

    switch (searchTypeInput) {
      case 'WEB':
        tempMediaType = 'WEB';
        if (docIdInput?.includes('investing')) {
          tempMediaType = 'INVESTING';
        }
        if (docIdInput?.includes('dart')) {
          tempMediaType = 'DART';
        }
        if (docIdInput?.includes('webscrap') || docIdInput?.includes('webScrap')) {
          tempMediaType = 'WEBSCRAP';
        }
        break;
      case 'NEWS':
        tempMediaType = 'NEWS';
        break;
      case 'VIDEO':
        tempMediaType = 'VIDEO';
        break;
      case 'FILE':
        tempMediaType = 'WEB';
        if (docIdInput?.includes('pdf')) {
          tempMediaType = 'PDF';
        }
        if (docIdInput?.includes('ppt')) {
          tempMediaType = 'PPT';
        }
        if (docIdInput?.includes('doc')) {
          tempMediaType = 'DOC';
        }
        break;
      case 'PDF':
        tempMediaType = 'PDF';
        break;
      case 'PPT':
        tempMediaType = 'PPT';
        break;
      case 'DOC':
        tempMediaType = 'DOC';
        break;
      case 'PPTX':
        tempMediaType = 'PPT';
        break;
      case 'DOCX':
        tempMediaType = 'DOC';
        break;
      case 'PROFILE':
        if (docIdInput?.includes('people')) {
          tempMediaType = 'PEOPLE';
        } else {
          tempMediaType = 'COMPANY';
        }
        break;
      case 'SOCIAL':
        if (docIdInput?.includes('post')) {
          tempMediaType = 'POST';
        }
        if (docIdInput?.includes('comment')) {
          tempMediaType = 'COMMENT';
        }
        if (docIdInput?.includes('reply')) {
          tempMediaType = 'REPLY';
        }
        if (docIdInput?.includes('answer')) {
          tempMediaType = 'ANSWER';
        }
        if (docIdInput?.includes('question')) {
          tempMediaType = 'QUESTION';
        }
        if (docIdInput?.includes('topic')) {
          tempMediaType = 'TOPIC';
        }
        if (docIdInput?.includes('facebook')) {
          tempMediaType = 'FACEBOOK';
        }
        if (docIdInput?.includes('twiter')) {
          tempMediaType = 'TWITER';
        }
        if (docIdInput?.includes('linkedin') || docIdInput?.includes('linkedIn')) {
          tempMediaType = 'LINKEDIN';
        }
        if (docIdInput?.includes('instagram')) {
          tempMediaType = 'INSTAGRAM';
        }
        if (docIdInput?.includes('youtube')) {
          tempMediaType = 'YOUTUBE';
        }
        break;
      case 'REPORT':
        tempMediaType = 'REPORT';
        break;
      case 'USERNOTE':
        tempMediaType = 'USERNOTE';
        break;
      default:
        tempMediaType = 'WEB';
    }

    return tempMediaType;
  }

  selectAddingReferenceDocument(item) {
    let index = -1;

    if (this.selectedItems !== null && this.selectedItems.length > 0) {
      index = this.selectedItems.indexOf(item);
    }

    if (index !== -1) {
      this.selectedItems.splice(index, 1);
      this.removeReferenceDocument(item);
    } else {
      this.selectedItems.push(item);
      this.setAddingReferenceDocuments([...(this.getAddingReferenceDocuments ? this.getAddingReferenceDocuments : []), item]);
    }
  }

  removeReferenceDocument(item) {
    if (this.getAddingReferenceDocuments !== null && this.getAddingReferenceDocuments.length > 0) {
      const index = this.getAddingReferenceDocuments.indexOf(item);

      if (index !== -1) {
        this.getAddingReferenceDocuments.splice(index, 1);
        this.setAddingReferenceDocuments(this.getAddingReferenceDocuments);
      }
    }
  }

  openNewTab(url: string) {
    window.open(url, '_blank');
  }
}
